// 是否在极速版中
export function inKsNebula() {
  return /\sksNebula\//.test(navigator.userAgent);
}

export function getKwaiVersion() {
  const versions = window.navigator.userAgent.match(/Kwai\/(\d+(\.\d+){1,2})/);
  if (versions && versions[1]) {
    return versions[1];
  }
  return '';
}

export function getKsNebulaVersion() {
  const versions = window.navigator.userAgent.match(
    /ksNebula\/(\d+(\.\d+){1,2})/
  );
  if (versions && versions[1]) {
    return versions[1];
  }
  return '';
}

export const SUPPORT_SUBJECT_VER = '8.2.30';

// 支持二维码跳转的最低版本
export const SUPPORT_QRCODE_VER = '9.5.20';

/*
 * 比较版本号
 * @param  {string} source 比较源
 * @param  {string} target 比较目标
 * @return {inter} 前者大返回>0, 相等返回0, 前者小返回<0
 */
export function compareAppVersion(source, target) {
  const sourceArr = source.split('.');
  const targetArr = target.split('.');

  for (let i = 0; i < targetArr.length; i++) {
    if (sourceArr[i] !== targetArr[i]) {
      sourceArr[i] = isNaN(sourceArr[i]) ? 0 : sourceArr[i];
      targetArr[i] = isNaN(targetArr[i]) ? 0 : targetArr[i];
      return sourceArr[i] - targetArr[i];
    }
  }
  return 0;
}
